
import styles from '../index.css'
import bylineStyles from '../stylesheets/byline.css'

const shareButtons = () => `
  <nav class="${bylineStyles['byline--sharebutton--container']}">
    <ul class="${bylineStyles['byline--sharebutton--group']}">
      <li class="${bylineStyles['byline--sharebutton--item']}">
        <a class="${styles['to-top']}"  href="#">
          <strong>Gå til toppen</strong>
          <button class="nrk-button nrk-button--o">
            <svg width="30" height="30" aria-hidden="true">
              <use xlink:href="#nrk-chevron-up" />
            </svg>
          </button>
        </a>
      </li>
      <li class="${bylineStyles['byline--sharebutton--item']}">
        <a class="" data-share="Article:Facebook" rel="noopener" target="_blank" href="https://www.facebook.com/sharer.php?u=https://www.nrk.no/min-reise-i-krigens-syria-1.13652870">
          Del på Facebook
          <button class="nrk-button nrk-button--o">
            <svg width="30" height="30" aria-hidden="true">
              <use xlink:href="#nrk-some-facebook" />
            </svg>
          </button>
        </a>
      </li>
      <li class="${bylineStyles['byline--sharebutton--item']}">
        <a class="" data-share="Article:Twitter" rel="noopener" target="_blank" href="https://twitter.com/intent/tweet?url=https://www.nrk.no/min-reise-i-krigens-syria-1.13652870;text=Min reise i krigens Syria">
          Del på Twitter
          <button class="nrk-button nrk-button--o">
            <svg width="30" height="30" aria-hidden="true">
              <use xlink:href="#nrk-some-twitter" />
            </svg>
          </button>
        </a>
      </li>
    </ul>
  </nav>
`

const seeMore = () => {
  return `
    <div class="${bylineStyles['seemore--block']}">
      <h2 class="${bylineStyles['seemore--heading']}">Lær og forstå mer om Syria</h2>
      <a class="${bylineStyles['seemore--heading-link']}" href="https://www.nrk.no/emne/syria-1.6931818">
        <span>Alt om borgerkrigen i Syria</span>
        <svg width="30" height="30" aria-hidden="true">
          <use xlink:href="#nrk-arrow-right-long" aria-hidden="true" />
        </svg>
      </a>
      <div class="${bylineStyles['seemore--link--list--wrapper']}">
        <ul class="${bylineStyles['seemore--link--list']}">
          <li class="${bylineStyles['seemore--link--item']}">
            <div>
              <a href="https://www.nrk.no/video/PS*293556" alt="Urik forklarer: Syria (3 min)">
                <div class="${bylineStyles['seemore--link--image']}">
                  <img id="VTV9_ybKJ0cy6a9QCN8u_g" sizes="100vw" srcset="https://gfx.nrk.no/VTV9_ybKJ0cy6a9QCN8u_gDtrzfLDePbMQOgvUGjyqXA 80w, https://gfx.nrk.no/VTV9_ybKJ0cy6a9QCN8u_giH7ylL63VJYQOgvUGjyqXA 160w, https://gfx.nrk.no/VTV9_ybKJ0cy6a9QCN8u_g2EMRXwlpXNoQOgvUGjyqXA 350w" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" alt="I snart seks år har de prøvd å styrte Bashar al-Assad, men han biter seg fast til makta. Hvordan ligger presidenten i Syria an nå? Urix forklarer!" title="">
                  <svg width="30" height="30" aria-hidden="true"><use xlink:href="#nrk-media-play" /></svg></div>
                <h3>Urix forklarer: Syria (3 min)</h3>
              </a>
              <p>
                I snart seks år har de prøvd å styrte Bashar al-Assad, men han biter seg fast til makta. Hvordan ligger presidenten i Syria an nå? Urix forklarer!
              </p>
            </div>
          </li>

          <li class="${bylineStyles['seemore--link--item']}">
            <div>
              <a href="https://tv.nrk.no/program/mddp22001616/vaare-allierte" alt="">
                <div class="${bylineStyles['seemore--link--image']}">
                  <img src="https://gfx.nrk.no/NIK7DSVPE8AJNYzHbf4kPgPodgvgOT88_VU_APzA87KA"
                  alt="" >
                  <svg width="30" height="30" aria-hidden="true"><use xlink:href="#nrk-media-play" /></svg>
                </div>
                <h3>Våre allierte (1 time)</h3>
              </a>
              <p>
                Norsk dokumentar. Norge har sendt ut soldater for å delta i krigen mot IS i Irak og Syria.
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  `
}

const byline = () => {
  return `
    <div class="${bylineStyles['byline--block']}">
      <ul class="${bylineStyles['byline--credit--list']}">

        <li class="${bylineStyles['byline--credit--list--item']}">
          <h4 class="${bylineStyles['byline--credit--list--item--role']}">Journalist</h4>
          <p><a class="${bylineStyles['byline--credit--list--item--names']}" href="mailto:kristin.solberg@nrk.no">Kristin Solberg</a><p>
        </li>

        <li class="${bylineStyles['byline--credit--list--item']}">
          <h4 class="${bylineStyles['byline--credit--list--item--role']}">Digital historieutvikling</h4>
          <p class="${bylineStyles['byline--credit--list--item--names']}">Ragnar Aasen Rognstad, Kari Anne Gisestad Andersen og Johannes Odland</p>
        </li>

        <li class="${bylineStyles['byline--credit--list--item']}">
          <h4 class="${bylineStyles['byline--credit--list--item--role']}">Nyhetsredaktør</h4>
          <p class="${bylineStyles['byline--credit--list--item--names']}">Alexandra Beverfjord</p>
        </li>

        <li class="${bylineStyles['byline--credit--list--item']}">
          <h4 class="${bylineStyles['byline--credit--list--item--role']}">Ansvarlig redaktør</h4>
          <p class="${bylineStyles['byline--credit--list-item-names']}">Thor Gjermund Eriksen</p>
        </li>

        <li class="${bylineStyles['byline--credit--list--item']}">
          <h4 class="${bylineStyles['byline--credit--list--item--role']}">Nettsjef</h4>
          <p class="${bylineStyles['byline--credit--list--item--names']}">Hildegunn Soldal</p>
        </li>

        <li class="${bylineStyles['byline--credit--list--item']}">
          <p style="margin-top: 40px" class="${bylineStyles['byline--credit--list--item--names']}">
            Publisert 27.08.2017
          </p>
        </li>
      </ul>
    </div>
  `
}

export const bylineSection = (id) => {

  return `
    <div
      class="${styles.section} ${bylineStyles.bylineSection}"
      data-background-id="${id}"
      data-background-byline="true"
    >
      ${shareButtons()}
      ${seeMore()}
      ${byline()}
    </div>
  `
}



// WEBPACK FOOTER //
// ./src/shared/sections/section8_byline.js